module.exports = __webpack_public_path__ + "static/media/eocene_image_blood_monitor_transparent.9a216629.png";